import React from 'react';
import { observer } from 'mobx-react-lite';

import { gameStore } from '../../store/gameStore';

const RoundResultPart = observer(() => {
  const { pastRoundsData } = gameStore;

  return (
    <div className='strike-history-row-wrapper'>
      <ul className='strike-history-row'>
        {pastRoundsData.map((myBet) => (
          <li className={`strike-history-el ${myBet.winAmount ? 'win' : 'lose'}`} key={myBet.id}>
            <span>x{+myBet.roundData}</span>
          </li>
        ))}
      </ul>
    </div>
  );
});

export default RoundResultPart;
